import React from "react";
import InterphoneView from "./InterphoneView";
import { UseInterphoneProps } from "./type";
import { useInterphone } from "./useInterphone";

function Interphone() {
  const hook: UseInterphoneProps = useInterphone();

  return <InterphoneView hook={hook} />;
}
export default React.memo(Interphone);
